import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const FooterCopyright = styled.p`
  font-size: 14px;
  line-height: 150%;
  text-align: right;
`;

const FooterMenu = styled.div`
  align-items: center;
  display: flex;
  gap: 8px;
`;

const FooterItem = styled.a`
  align-items: center;
  color: var(--color-fg-weakest);
  display: flex;
  font-size: 14px;
  line-height: 150%;
  text-decoration-line: underline;
`;

const Footer = styled.div`
  align-items: center;
  color: var(--color-fg-weakest);
  display: flex;
  justify-content: space-between;
  padding: 40px;
  z-index: 1;

  ${DEVICE.mobile.max} {
    flex-direction: column;
    padding: var(--size-page-padding-sm);

    ${FooterCopyright} {
      margin-bottom: 4px;
      order: 1;
      text-align: center;
    }
    ${FooterMenu} {
      flex-wrap: wrap;
      gap: 4px 8px;
      justify-content: center;
      order: 2;

      p {
        display: none;
      }
    }
  }
`;

const SupportLink = styled.a`
  color: var(--color-fg-weakest);
  text-decoration: underline;
`;

export { Footer, FooterCopyright, FooterItem, FooterMenu, SupportLink };
